module.exports = __webpack_public_path__ + "img/16m003-08.270ea9d9.png";